import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { node } from 'prop-types';
import { useLocations } from 'core/contexts/location';
import AppBar from 'components/AppBar';
import Footer from 'components/Footer';
import { Box } from '@mui/material';

const Layout = ({ children }) => {
    const location = useLocation();
    const { setPreviousLocation } = useLocations();

    useEffect(() => {
        setPreviousLocation(`${location.pathname}${location.search}`);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location]);

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <AppBar />
            <Box component="main" sx={{ flexGrow: 1, backgroundColor: '#f5f5f5' }}>
                {children}
            </Box>
            <Footer />
        </Box>
    );
};

Layout.propTypes = {
    children: node.isRequired,
};

Layout.displayName = 'Layout';

export default Layout;
